import {
    CREATE_AREA_START,
    CREATE_AREA_SUCCESS,
    CREATE_AREA_FAIL,
    UPDATE_AREA_START,
    UPDATE_AREA_SUCCESS,
    UPDATE_AREA_FAIL,
    REMOVE_BROKER_START,
    REMOVE_BROKER_SUCCESS,
    REMOVE_BROKER_FAIL,
    DELETE_AREA_START,
    DELETE_AREA_SUCCESS,
    DELETE_AREA_FAIL,
    FETCH_AREAS_START,
    FETCH_AREAS_SUCCESS,
    FETCH_AREAS_FAILED,
    CLEAR_AREA_ERROR,
} from "../store/types";

const INITIAL_STATE = {
    areas: [],
    currentArea: null,
    completed: false,
    loading: false,
    success: false,
    error: {
        flag: false,
        msg: null,
    },
};

export const areasreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CREATE_AREA_START:
            return {
                ...state,
                loading: true,
                completed: false,
                success: false,
            };

        case CREATE_AREA_SUCCESS:
            return {
                ...state,
                loading: false,
                completed: true,
                success: true,
                areas: [...state.areas, action.payload],
                currentArea: action.payload,
            };

        case CREATE_AREA_FAIL:
            return {
                ...state,
                loading: false,
                completed: true,
                success: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        case FETCH_AREAS_START:
            return {
                ...state,
                loading: true,
                completed: false,
                success: false,
            };

        case FETCH_AREAS_SUCCESS:
            return {
                ...state,
                loading: false,
                areas: action.payload,
            };

        case FETCH_AREAS_FAILED:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        case CLEAR_AREA_ERROR:
            return {
                ...state,
                completed: false,
                loading: false,
                success: false,
                error: {
                    flag: false,
                    msg: null,
                },
            };

        case UPDATE_AREA_START:
            return {
                ...state,
                loading: true,
                error: null, // Reset error on new update attempt
            };

        case UPDATE_AREA_SUCCESS:
            return {
                ...state,
                loading: false,
                areas: state.areas.map((area) =>
                    area.areaId === action.payload.areaId
                        ? { ...area, ...action.payload }
                        : area
                ),
                error: null, 
            };

        case UPDATE_AREA_FAIL:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        case DELETE_AREA_START:
            return {
                ...state,
                loading: true,
                error: null, 
            };

        case DELETE_AREA_SUCCESS:
            return {
                ...state,
                loading: false,
                areas: area?.areaId ? state.areas.filter(
                    (area) => area?.areaId !== action.payload.areaId
                ) : areas,
                error: null,
            };

        case DELETE_AREA_FAIL:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };
            case REMOVE_BROKER_START:
            return {
                ...state,
                loading: true,
                error: null, 
            };

        case REMOVE_BROKER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };

        case REMOVE_BROKER_FAIL:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        default:
            return state;
    }
};
